<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail User Staff</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA USER</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Username</b-col>
                    <b-col>{{ userStaff.username }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Full Name</b-col>
                    <b-col>{{ userStaff.fullname }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Level - Role</b-col>
                    <b-col>{{ userStaff.role.level }} - {{ userStaff.role.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Cabang</b-col>
                    <b-col v-if="userStaff.cabang != {}">{{ userStaff.cabang.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Email</b-col>
                    <b-col>{{ userStaff.email }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. HP</b-col>
                    <b-col>{{ userStaff.noHp }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="userStaff.isActive == true">Aktif</b-col>
                    <b-col v-else>Tidak Aktif</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-show="dataCabang == true">
                <h6 class="form-title">DATA CABANG</h6>
                <ul class="list-circle-wrapper">
                    <li v-for="cabangKc in userStaff.cabangAsKc" v-bind:key="cabangKc">{{ cabangKc }}</li>
                    <li v-for="(cabangKcs, index) in userStaff.cabangAsKcs" v-bind:key="index">{{ cabangKcs }}</li>
                </ul>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">AKSES LOG</h6>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="filterFromDate" name="filterFromDate"
                                id="filterInput"
                                type="date"
                            ></b-form-input>
                            <span class="mr-2 d-flex align-items-center">to</span>
                            <b-form-input class="mr-2" 
                                v-model="filterToDate" name="filterToDate"
                                type="date"
                            ></b-form-input>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="dataLog" 
                    :fields="fields"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data log.
                    </template>
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template v-slot:cell(time)="row">
                        <div>{{$helper.changeDateFormat(row.item.time)}} {{$helper.changeDateFormatGetHour(row.item.time)}}</div>
                    </template>
                    <template v-slot:cell(success)="row">
                        <div class="no-wrap">
							<i class="fa fa-check log-success" v-if="row.item.success == true" ></i>
							<i class="fa fa-times log-failed" v-else></i>
							<b-badge class="ml-2" variant="danger" v-if="row.item.suspect == true">Suspect</b-badge>
						</div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" class="mr-2" name="userStaffEditBtn" @click="editUserStaff">Edit User Staff</b-button>
                <b-button variant="danger" name="resetPasswordBtn" @click="openModalConfirm">Reset Password</b-button>
            </div>
        </b-card>
        <ModalConfirm id="modal-confirm-reset" title="Confirm Reset Password" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mereset password ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'detail-user-staff',
    data(){
        return{
            id: null,
            isBusy: true,
            isSubmitting: false,
            initStatus: 0,
            input:{
                show: 10,
            },
            fields: [
                { key: "index", label: "No. ", tdClass: "indexNo" },
                { key: "time", label: "Tanggal"},
                { key: "ip", label: "IP Address"},
                { key: "success", label: "Sukses"},
            ],
            dataLog: [],
            userStaff: [{
                cabang: []
            }],
            dataCabang: true,
            filterFromDate: null,
            filterToDate: null,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            query: "",
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.query = this.query+"&id="+this.id
            
            let getSingleUserStaff = this.$axios.get(`user/${this.id}`).then(response => {
                this.userStaff = response.data
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            //ganti api user
            let getAksesLog = this.$axios.get(`user/log/${this.id}/${this.query}`).then(response => {
                this.dataLog = response.data.data  
       
                this.updateTotalItem(response.data.total)
            })

            Promise.all([getSingleUserStaff, getAksesLog]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getAksesLog(){
            this.toggleBusy()
            this.dataLog = []

            if(this.$helper.isNotNullAndNotEmpty(this.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.filterFromDate
            if(this.$helper.isNotNullAndNotEmpty(this.filterToDate)) this.query = this.query + "&filterEndDate=" + this.filterToDate
			
			this.$axios.get(`user/log/${this.id}/${this.query}`).then(response => {
                this.dataLog = response.data.data
                this.updateTotalItem(response.data.total)
        
                this.toggleBusy()
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        onSubmit(){
            let payload = new FormData()
            payload.append("userId", this.id)

            this.isSubmitting = true
            this.$axios.post("user/resetPassword", payload).then(response => {

                this.$bvModal.hide("modal-confirm-reset")
                this.$helper.toastSucc(this, "Password berhasil direset kembali ke 123456")

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            // this.query = this.query+"&id="+this.id
            this.getAksesLog()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getAksesLog()
            }
        },

        onReset(){
            this.filterFromDate = null
            this.filterToDate = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getAksesLog()
        },

        onFilter(){
            if(!this.$helper.isNotNullAndNotEmpty(this.filterFromDate) || !this.$helper.isNotNullAndNotEmpty(this.filterToDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(Date.parse(this.filterToDate) < Date.parse(this.filterFromDate)){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.page = 0
                this.currentPage = 1
                this.query = this.$helper.makeQuery(0, this.size)
                this.loading = true
                this.getAksesLog()
            }
            
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-reset")
        },

        editUserStaff(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        }

    },

    created(){
        this.init()
    }
}
</script>
